/**
 * OpenApp: merchantPanel
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MerchantAuthInit { 
    email: string;
    country: MerchantAuthInit.CountryEnum;
}
export namespace MerchantAuthInit {
    export const CountryEnum = {
        Pl: 'PL'
    } as const;
    export type CountryEnum = typeof CountryEnum[keyof typeof CountryEnum];
}


